<template>
    <div v-if="spinner==true" class="spinner"></div>
    <section :class="content" :style="{ backgroundImage: 'url(' + require('@/assets/img/login-screen.webp') + ')', backgroundSize: 'cover', backgroundPosition: 'top right' }">
        <div class="version-tag">{{ version }}</div>
        <div class="container-fluid" style="height: calc(100% - 73px);">
            <div class="row d-flex justify-content-center align-items-center  ">
                <div class=" ">
                    
                    <form class="p-5 form-position"   >
                        <!-- Usuario input -->
                        <div class="form-outline mb-3">
                            <label class="form-label " for="usuario-login">Usuario</label>
                            <input type="text" id="usuario-login" placeholder="Introduce usuario" v-model="usuario" class="form-control form-control-lg"/>
                        </div>

                        <!-- Contraseña input -->
                        <div class="form-outline mb-3">
                            <label class="form-label " for="contrasenya-login">Contraseña</label>
                            <input type="password" id="contrasenya-login" placeholder="Introduce contraseña" v-model="password" class="form-control form-control-lg"/>
                        </div>

                        <div class="d-flex justify-content-between align-items-center">
                            <a href="#!" class="text-body" @click.prevent="openModal">¿Contraseña olvidada?</a>
                        </div>

                        <div class="text-center text-lg-start mt-4 pt-2">
                            <button type="button" class="btn btn-info btn-lg"
                            style="padding-left: 2.5rem; padding-right: 2.5rem;" @click.prevent="login">Login</button>
                            <p class="small fw-bold mt-2 pt-1 mb-0 ">¿Quieres PWGS Quantum para tu negocio? <a href="https://reparadoreshogar.com/solicitar-una-demo-pwgs/"
                                class="link-danger " target="_blank"><strong><u>Solicita una demo</u></strong></a></p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div
            class="d-flex flex-column flex-md-row text-center text-md-start justify-content-between py-4 px-4 px-xl-5 ">
            <div class="mb-3 mb-md-0">
            Copyright &copy; 2025. Todos los derechos reservados.
            </div>
        </div>
    </section>

    <!-- MODAL RECUPERAR CONTRASE�A -->
    <div v-if="showModal" class="modal fade show" style="display: block; background-color: rgba(0, 0, 0, 0.5);" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header d-flex flex-column align-items-start">
                    <div class="d-flex justify-content-between w-100">
                        <h4 class="modal-title">Recuperar contrase&ntilde;a</h4>
                    </div>
                    <div class="row w-100 mt-2">
                        <div class="col-12 bg-warning p-2 rounded">
                            <h6 class="mb-0 text-dark">S&oacute;lo disponible para usuarios de tramitaci&oacute;n y operarios. En caso contrario, contacte con administraci&oacute;n.</h6>
                        </div>
                    </div>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="enviarRecuperacion">
                        <div class="form-group mb-3">
                            <label class="form-label">Introduce e-mail</label>
                            <input type="email" v-model="recuperarEmail" class="form-control" placeholder="e-mail especificado en los datos de usuario">
                        </div>
                        
                        <div class="form-group mb-3">
                            <p class="help-block text-muted small">Si eres un operario y no dispones de e-mail de recuperaci&oacute;n, podemos enviarte un SMS a tu n&uacute;mero m&oacute;vil con instrucciones para especificar tu e-mail de recuperaci&oacute;n. El n&uacute;mero debe estar registrado a tu usuario, en caso contrario, deber&aacute;s proporcionar los datos a administraci&oacute;n.</p>
                            <label class="form-label">Introduce n&uacute;mero</label>
                            <input type="text" v-model="recuperarMovil" class="form-control" placeholder="Tu n&uacute;mero de m&oacute;vil">
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
                    <button type="button" class="btn btn-primary" @click="enviarRecuperacion">Enviar</button>
                </div>
            </div>
        </div>
    </div>

    <!-- NUEVO MODAL PARA EL CODIGO 2FA -->
    <div v-if="showModal2FA" class="modal fade show" style="display: block; background-color: rgba(0, 0, 0, 0.6);" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Verificaci&oacute;n de Seguridad (2FA)</h5>
                </div>
                <div class="modal-body">
                    <div class="alert alert-info text-center small mb-3">
                        Hemos enviado un c&oacute;digo de verificaci&oacute;n por <strong>{{ tipo2FA }}</strong>. Introduce el c&oacute;digo a continuaci&oacute;n para continuar.
                    </div>
                    <div class="form-group mb-3 text-center">
                        <label class="form-label fw-bold mb-2">Introduce el c&oacute;digo de verificaci&oacute;n</label>
                        <input type="text" v-model="codigo2FA" class="form-control form-control-lg text-center letter-spacing-lg" placeholder="123456" maxlength="8" autofocus>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-secondary" @click="cancelar2FA">Cancelar</button>
                    <button type="button" class="btn btn-primary px-4" @click="verificarCodigo2FA">Verificar e iniciar sesi&oacute;n</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.form-position {
    position: absolute;
    top: 50%; /* Ajusta este valor para mover el formulario hacia arriba o abajo */
    right: 0%;
    transform: translate(-20%, -50%);
    width: 100%;
    max-width: 500px; /* Asegúrate de que el formulario no sea demasiado ancho */
    border: 1px solid #ccc; /* Borde gris fino */
    padding: 20px; /* Espaciado interno para que no quede pegado al borde */
    border-radius: 15px; /* Bordes ligeramente redondeados (opcional) */
    background: #fff; /* Fondo blanco para que se vea bien */
}
@media (max-width: 768px) {
    .form-position {
        top: 10%; /* Menor desplazamiento en pantallas peque�as para evitar que se corte */
    }
}
.version-container {
    position: absolute;
    right: 30px;
    bottom: 30px;
    color: rgb(215, 211, 211); 
    font-size: 0.9rem;
}
.version-tag {
    position: absolute;
    right: 146px;  
    top: 965px; 
    border-radius: 5px;
    font-size: 12px;
    transform: rotate(9deg) skew(12deg); /* Ajusta la rotación y la deformación para alinear con la perspectiva */
    color: #cdcdcd;
    font-weight: bold;
    width: 200px;
    text-align: center;
}
.letter-spacing-lg {
    letter-spacing: 4px;
    font-size: 1.5rem;
}
</style>

<script>
import { PwgsApi } from './../../../services/PwgsApi.js'
import { ENTORNO_APUYEN } from './../../../../.env.js';
import { messaging, getToken } from '@/firebase';

export default {
    data() {
        return {
            usuario: null,
            password: null,
            direccion: "",
            version: '',
            errorlogin:'',
            spinner: false,
            content : 'vh-100',
            showModal: false,
            recuperarEmail: '',
            recuperarMovil: '',
            showModal2FA: false,
            tipo2FA: '', 
            codigo2FA: '',
            datosUsuarioTemp: null, 
            datosLoginTemp: null   
        }
    },
    async mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        const tokenAutologin = urlParams.get('token');
        const usuarioAutologin = urlParams.get('user');
        const idUsuarioDestino = urlParams.get('id_user');

        //AUTOLOGIN DESDE PLATAFORMA
        if (tokenAutologin && usuarioAutologin && idUsuarioDestino) {
            this.spinner = true;
            this.content = 'vh-100 difuminado';
            try {
                let username = usuarioAutologin;
                let subdomain = '';
                if (usuarioAutologin.includes('@')) {
                    const parts = usuarioAutologin.split('@');
                    username = parts[0];
                    subdomain = parts[1].split('.')[0];
                    localStorage.setItem('subdomain', subdomain);
                } else {
                    localStorage.removeItem('subdomain');
                }
                localStorage.setItem('nombreusuario', username);
                localStorage.setItem('token', tokenAutologin);
                localStorage.setItem('tramitador', username);
                
                localStorage.setItem('usuario_temporal', idUsuarioDestino);

                window.location.href = window.location.origin + "/login?autologin_step2=1";

            }catch(error){
                console.error("[Autologin] Error al guardar datos:", error);
                localStorage.removeItem('token');
                this.spinner = false;
                this.content = 'vh-100';
            }
        } 
        else if(localStorage.getItem('token') && localStorage.getItem('usuario_temporal')){            
            this.spinner = true;
            this.content = 'vh-100 difuminado';
            try{
                const idUsuarioDestino = localStorage.getItem('usuario_temporal');
                const subdomain = localStorage.getItem('subdomain') || '';
                
                const api = new PwgsApi(subdomain);
                const auxusuarios = await api.get('usuarios/' + idUsuarioDestino);
                
                if (auxusuarios && auxusuarios.datos) {
                    const datosusuarios = auxusuarios.datos;

                    if (datosusuarios.tipo_2fa === 'EMAIL' || datosusuarios.tipo_2fa === 'SMS') {
                        this.solicitarVerificacion2FA(datosusuarios, { tokenId: localStorage.getItem('token'), id_usuario: idUsuarioDestino });
                        return;
                    }
                    this.completarInicioSesion(datosusuarios);
                }else{
                    throw new Error("La API siguió rechazando el token tras la recarga.");
                }
            }catch(e){
                console.error("[Autologin] Error en Paso 2:", e);
                this.destruirSesion();
            }
        }
    },
    methods: {
        async login() {
            this.spinner = true;
            this.content = 'vh-100 difuminado';
            if (this.usuario.trim() === '' || this.password.length < 6)  {
                alert('Faltan datos. La contraseña debe tener mínimo 6 caracteres');
                this.spinner = false;
                this.content = 'vh-100';
                return;
            }

            let username;  
            let subdomain = '';

            if (this.usuario.includes('@')) {
                const parts = this.usuario.split('@');
                username = parts[0];
                const domain = parts[1];
                subdomain = domain.split('.')[0];  
                localStorage.setItem('subdomain', subdomain); 
            } else {
                username = this.usuario;  
                localStorage.removeItem('subdomain'); 
            }
            try {
                const servicio = new PwgsApi(subdomain);
                const api = new PwgsApi(subdomain);
                const datos = await servicio.login(username, this.password);
                this.errorlogin = datos;

                localStorage.setItem('nombreusuario', username);
                localStorage.setItem('token', datos.tokenId);
                localStorage.setItem('tramitador', username);
                
                const auxusuarios = await api.get('usuarios/'+datos.id_usuario);
                const datosusuarios = auxusuarios.datos;

                if(datosusuarios.tipo_2fa === 'EMAIL' || datosusuarios.tipo_2fa === 'SMS'){
                    this.solicitarVerificacion2FA(datosusuarios, datos);
                    return;
                }else{
                    await this.completarInicioSesion(datosusuarios);
                }
                
            } catch (error) {                                
                alert(this.errorlogin ? this.errorlogin.descripcionInciencia : error);
                this.destruirSesion(subdomain);
            }
        },
        solicitarVerificacion2FA(datosusuarios, datosLogin) {
            this.datosUsuarioTemp = datosusuarios;
            this.datosLoginTemp = datosLogin;
            this.tipo2FA = datosusuarios.tipo_2fa;
            this.codigo2FA = '';
            
            this.spinner = false; 
            this.showModal2FA = true; 
        },
        async verificarCodigo2FA() {
            if (!this.codigo2FA.trim()) {
                alert('Por favor, introduce el código de verificación.');
                return;
            }
            this.spinner = true;
            this.showModal2FA = false; 

            try {
                const subdomain = localStorage.getItem('subdomain') || '';
                const api = new PwgsApi(subdomain);

                const payload = {
                    id_usuario: this.datosUsuarioTemp.idusuario,
                    codigo: this.codigo2FA.trim()
                };
                const verificacion = await api.put('otros/verificar-2fa', payload);

                if (verificacion && verificacion.valido) {
                    localStorage.setItem('nombreusuario', this.usuario || localStorage.getItem('nombreusuario'));
                    localStorage.setItem('token', this.datosLoginTemp.tokenId);
                    localStorage.setItem('tramitador', this.usuario || localStorage.getItem('nombreusuario'));

                    await this.completarInicioSesion(this.datosUsuarioTemp);
                } else {
                    throw new Error("El código de verificación es incorrecto o ha caducado.");
                }

            } catch (error) {
                alert(error.message || error);
                this.destruirSesion();
            } finally {
                this.datosUsuarioTemp = null;
                this.datosLoginTemp = null;
            }
        },
        cancelar2FA() {
            this.showModal2FA = false;
            this.destruirSesion();
        },
        async completarInicioSesion(datosusuarios) {
            localStorage.setItem('usuario', datosusuarios.idusuario);
            localStorage.setItem('extension', datosusuarios.extension);
            localStorage.removeItem('usuario_temporal'); 

            await this.historialurls(datosusuarios.idusuario);
            this.monitorizarErrores(localStorage.getItem('nombreusuario'));
            this.meterurl();
            
            this.registrarFirebase();

            this.$router.push({
                name: 'Escritorio'
            });
        },
        destruirSesion(subdomain = '') {
            const api = new PwgsApi();
            api.get('logout'); 
            const apidos = new PwgsApi(subdomain || localStorage.getItem('subdomain') || '');
            apidos.get('logout');
            localStorage.removeItem('token');
            localStorage.removeItem('usuario_temporal');
            this.spinner = false;
            this.content = 'vh-100';
        },
        registrarFirebase() {
            navigator.serviceWorker
                .register('/firebase-messaging-sw.js')
                .then((registration) => {
                    getToken(messaging, { 
                        vapidKey: 'BF9dHbgLHL3lSgZ0lq5k8rrxP9iYcWTZHL8NU3cDQ48fEd6c0KZHVBEolRMprAfdZFmiv5fCUQriyOh_3WFf07Q',
                        serviceWorkerRegistration: registration
                    })
                    .then((token) => {
                        if (token) {
                            console.log('Token de dispositivo:', token);
                            const api = new PwgsApi();
                            let subidadatos = { token_firebase: token };
                            api.put('usuarios/' + localStorage.getItem('usuario') + '/tokenFirebase/', subidadatos);
                        } else {
                            console.log('No se pudo obtener el token.');
                        }
                    })
                    .catch((err) => {
                        console.error('Error al obtener token:', err);
                    });
                })
                .catch((err) => {
                    console.log('Service worker registration failed: ', err);
                });
        },
        meterurl() {
            var domain = "";
            if(localStorage.getItem('subdomain')!=''){
                domain = localStorage.getItem('subdomain')+".pwgs.app";
            }else{
                let aux = ENTORNO_APUYEN.BaseURL;
                const url = new URL(aux);
                domain = url.hostname;
            }
            localStorage.setItem('direccion', domain);
        },
        async historialurls(idusuario) {
            const api = new PwgsApi();
            let datosusuario = await api.get('usuarios/' + idusuario);
            this.$router.push('/escritorio');
            for (let i = 0; i < datosusuario.datos.pestanas.length; i++){
                let ruta = { path: datosusuario.datos.pestanas[i].path, fullPath: datosusuario.datos.pestanas[i].fullPath, name: datosusuario.datos.pestanas[i].name }
                this.$store.dispatch('agregarVentana', ruta);
            }
        },
        monitorizarErrores(usuario){
            var initOpts = {
                projectKey: "rMVhQP7dYnFONci3F4h7",
                ingestPoint: "https://monitorapp.grupoapuyen.net/ingest",
                defaultInputMode: 0,
                obscureTextNumbers: false,
                obscureTextEmails: true,
            };
            var startOpts = { userID: usuario };
            (function(A,s,a,y,e,r){
                r=window.OpenReplay=[e,r,y,[s-1, e]];
                s=document.createElement('script');s.src=A;s.async=!a;
                document.getElementsByTagName('head')[0].appendChild(s);
                r.start=function(){r.push([0])};
                r.stop=function(){r.push([1])};
                r.setUserID="function(id){r.push([2,id])}";
                r.setUserAnonymousID="function(id){r.push([3,id])}";
                r.setMetadata=function(k,v){r.push([4,k,v])};
                r.event=function(k,p,i){r.push([5,k,p,i])};
                r.issue=function(k,p){r.push([6,k,p])};
                r.isActive=function(){return false};
                r.getSessionToken=function(){};
            })("//static.openreplay.com/13.0.0/openreplay-assist.js",1,0,initOpts,startOpts);
        },
        openModal() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.recuperarEmail = '';
            this.recuperarMovil = '';
        },
        async enviarRecuperacion() {
            if(!this.recuperarEmail.trim() && !this.recuperarMovil.trim()){
                alert('Por favor, introduce tu e-mail o tu n&uacute;mero de móvil para continuar.');
                return;
            }
            this.spinner = true;
            this.content = 'vh-100 difuminado';

            try{
                const subdomain = localStorage.getItem('subdomain') || '';
                const api = new PwgsApi(subdomain);

                if(this.recuperarEmail.trim() !== ''){
                    let datosPayload = { email: this.recuperarEmail.trim() };
                    await api.put('otros/enviar-email-recuperar-password', datosPayload);
                    alert('Si el correo existe en nuestra base de datos, recibirás un e-mail de recuperación en unos instantes.');
                }else{
                    let datosPayload = { movil: this.recuperarMovil.trim() };
                    await api.put('otros/enviar-sms-recuperar-password', datosPayload);
                    alert('Si el número está registrado, recibirás un SMS con las instrucciones.');
                }
                this.closeModal();

            }catch(error){
                alert(error);
            }finally{
                this.spinner = false;
                this.content = 'vh-100';
            }
        }
    }
}
</script>
<style scoped>
.difuminado{
    filter: blur(6px);
    pointer-events: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.card {
    width: 50%;
    margin: 20% auto;
}
.spinner {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: 9px solid;
    border-color: #d9e3ff;
    border-right-color: #007bff;
    animation: spinner-d3wgkg 1s infinite linear;
    position: absolute;
    z-index:1000;
    top: 50%;
    left: 50%;
    margin-left: -50px;
    margin-top: -50px;
}
@keyframes spinner-d3wgkg {
    to {
        transform: rotate(1turn);
    }
}
</style>